import { RootState } from "../..";

export const clientSelector = (state: RootState) => state.client;
